import {
  CANCEL_BODY_SITE_SURVEY,
  CHECKOUT_SITE_SURVEY_TEST_IDS,
  SiteSurveyCancelAppointmentModal as SharedSiteSurveyCancelAppointmentModal,
} from "./siteSurveyScheduling";

type Props = {
  cancellationReasons: Array<{ label: string; value: string }>;
  onSubmit: (reason: string) => void;
  onClose: () => void;
  name: string;
  loading?: boolean;
};

const SiteSurveyCancelAppointmentModal: React.FC<Props> = ({
  name,
  ...rest
}) => (
  <SharedSiteSurveyCancelAppointmentModal
    testId={CHECKOUT_SITE_SURVEY_TEST_IDS.cancelModal}
    cancellationReasonSelectTestId={
      CHECKOUT_SITE_SURVEY_TEST_IDS.cancellationReasonSelect
    }
    loadingOverlayTestId={CHECKOUT_SITE_SURVEY_TEST_IDS.cancelLoadingOverlay}
    bodyLine1={CANCEL_BODY_SITE_SURVEY(name)}
    {...rest}
  />
);

export { SiteSurveyCancelAppointmentModal };
export type { Props };
